import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'jobs-history',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    container: {
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(2),
    },
    table: {
      '& td': {
        textAlign: 'center',
      },
      '& th': {
        textAlign: 'center',
        fontWeight: 600,
      },
    },
  }),
  options
);

export default useStyles;
